import React, { useState } from "react";

// core components
import Navbar from "components/Navbars/Navbar.js";
// import SubHeader from "components/Headers/SubHeaderSponsor";
import SubHeader from "components/Headers/SubHeaderBanner";
import DarkFooter from "components/Footers/DarkFooter.js";
import PanelCountdown from "components/PanelCountdown";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import "./style.scss";

const sponsorPackages = [
  {
    title: "Starlight Sponsor",
    description: (
      <>
        Shine a spotlight on your brand at{" "}
        <i>The FIBS Eclipse @ MOP (Moon on the Planet) </i>— our exclusive night
        event designed for high-impact networking in a vibrant setting.
      </>
    ),
    price: "7,999",
    details: [
      <>
        <strong>Exclusive Branding</strong> as the <i> Starlight Sponsor</i> for
        the night event at MOP (formerly Pasha)
      </>,
      <>
        <strong>1 VIP Table</strong> at the MOP nightclub with{" "}
        <strong>special bottle service</strong> and
        <strong> exclusive evening surprises</strong>
      </>,
      <>
        <strong>1 VIP Table</strong> for face-to-face meetings (dedicated table
        with priority placement)
      </>,
      <>
        <strong>2 Full Conference Passes</strong>
      </>,
      <>
        <strong>1 Full-Page Advertisement</strong> in the official conference
        booklet or directory
      </>,
      <>
        <strong>Company Logo</strong> on the official conference website with a
        direct link to your site
      </>,
      <>
        <strong>Stand-up Banner</strong> with your logo displayed at your VIP
        meeting table
      </>,
      <>
        <strong>Verbal Acknowledgement</strong> by the event host during the
        night event
      </>,
      <>
        <strong>Branded Banner or Pull-up</strong> displayed at the venue
        entrance
      </>,
      <>
        <strong>Logo Placement</strong> on the official event photo
        wall/backdrop
      </>,
      <>
        <strong>Mention in Post-Event Highlights</strong> (digital and print)
      </>,
      <>
        <strong>Opportunity to Distribute a Branded Giveaway Item</strong>{" "}
        (e.g., glowstick, wristband, party favour)
      </>,
    ],
    sponsors: [
      {
        name: "Schneider",
        logo: "schneider.png",
        url: "https://schneider-transport.com/",
      },
      {
        name: "Logisys ",
        logo: "Logi-Sys-new.png",
        url: "https://www.logi-sys.com/",
      },
    ],
  },
  {
    title: "Platinum Sponsor",
    description:
      "Position your brand at the forefront of the FIBS Global Conference with premium visibility and exclusive engagement opportunities.",
    price: "5,999",
    details: [
      <>
        <strong>1 VIP Table </strong>for face-to-face meetings (dedicated table
        with priority placement){" "}
      </>,
      <>
        <strong>2 Full Conference Passes </strong>
      </>,
      <>
        <strong>On-stage Toast Recognition </strong>during the Cocktail
        Party{" "}
      </>,
      <>
        <strong>Opportunity to Participate in a Panel Discussion</strong> during
        the main conference program{" "}
      </>,
      <>
        <strong>Branded Staplers </strong>with your logo placed on every
        face-to-face meeting table{" "}
      </>,
      <>
        <strong>1 Full-Page Advertisement </strong>in the official conference
        booklet or directory{" "}
      </>,
      <>
        <strong>Company Logo</strong> on the official conference website with a
        direct link to your site{" "}
      </>,
      <>
        <strong>Stand-up Banner</strong> with your logo displayed at your VIP
        meeting table{" "}
      </>,
      <>
        <strong>Logo Placement</strong> on the main backdrop at the Opening
        Ceremony{" "}
      </>,
      <>
        <strong>Logo Feature </strong>in post-conference video or official recap
        materials{" "}
      </>,
    ],
  },
  {
    title: "Gold Sponsor",
    description:
      "A strong branding package that offers excellent visibility and access throughout the conference.",
    price: "3,999",
    details: [
      <>
        <strong>1 VIP Table</strong> for face-to-face meetings (dedicated table
        with priority placement)
      </>,
      <>
        <strong>2 Full Conference Passes</strong>
      </>,
      <>
        <strong>On-stage Toast Recognition </strong>during the Cocktail Party
      </>,
      <>
        <strong>1 Full-Page Advertisement </strong>in the official conference
        booklet or directory
      </>,
      <>
        <strong> Company Logo </strong>on the official conference website with a
        direct link to your site
      </>,
      <>
        <strong>Stand-up Banner</strong> with your logo displayed at your VIP
        meeting table
      </>,
      <>
        <strong>Logo Placement </strong>on the main backdrop at the Opening
        Ceremony
      </>,
      <>
        <strong>Logo Feature </strong>in post-conference video or official recap
        materials
      </>,
      ,
    ],
    sponsors: [
      {
        name: "Quotiss",
        logo: "QUOTISS.png",
        url: "https://quotiss.com/",
      },
      {
        name: "Polish Forwarding Company",
        logo: "PFC.jpg",
        url: "https://pfc24.pl/en/",
      },
    ],
  },
  {
    title: "Happy Hour Sponsor",
    description: (
      <>
        Wrap up the conference with great visibility during the 1.5-hour{" "}
        <i>Free Flow Beer</i> networking session — the perfect opportunity to
        leave a lasting impression as delegates wind down.
      </>
    ),
    price: "2,999",
    slot: "Limited to 2 slots",
    details: [
      <>
        <strong>1 Full Conference Pass</strong>
      </>,
      <>
        <strong>1 Half-Page Advertisement</strong> in the official conference
        booklet or directory
      </>,
      <>
        <strong>Company Logo</strong> on the official conference website with a
        direct link to your site
      </>,
      <>
        {" "}
        <strong>Logo Placement</strong> on the main backdrop at the Opening
        Ceremony
      </>,
      <>
        <strong>Logo Feature</strong> in post-conference video or official recap
        materials
      </>,
    ],
  },
  {
    title: (
      <>
        <span style={{ fontSize: "24px" }}>FIBS GrandPrix Sponsor</span>
      </>
    ),
    description: (
      <>
        Put your brand in the driver’s seat as the exclusive sponsor of the{" "}
        <i>FIBS GrandPrix </i>— our arcade car racing competition where
        delegates race, connect, and celebrate in style.
      </>
    ),
    price: "4,999",
    details: [
      <>
        <strong>Exclusive Branding</strong> as the <i>FIBS GrandPrix Sponsor</i>{" "}
        across all racing-related promotional materials
      </>,
      <>
        <strong>1 Full Conference Pass</strong>
      </>,
      <>
        <strong>Popup Stand Placement</strong> at the competition area
      </>,
      <>
        <strong>Trophy/Prize Presentation</strong> as the official event sponsor
      </>,
      <>
        <strong>1 Full-Page Advertisement</strong> in the official conference
        booklet or directory
      </>,
      <>
        <strong>Company Logo</strong> on the official conference website with a
        direct link to your site
      </>,
      <>
        <strong>Logo Feature</strong> in the post-conference video or official
        recap materials
      </>,
    ],
    sponsors: [
      {
        name: "AgileBeyond",
        logo: "AgileBeyondLogo.png",
        url: "https://www.agilebeyond.net/",
      },
    ],
  },
  {
    title: (
      <>
        <span style={{ fontSize: "22px" }}>Half-Page Advertisement</span>
      </>
    ),
    description:
      "Maximise your brand exposure with a half-page advertisement in the official conference brochure — distributed to all delegates and referenced throughout the event.",
    price: "400",
    slot: "Limited to 4 slots",
    details: [
      <>
        <strong>1 Half-Page Advertisement</strong> in the official conference
        booklet or directory
      </>,
      <>
        <strong>High-visibility Placement</strong> alongside key conference
        content
      </>,
      <>
        <strong>Limited to 4 Slots</strong> — secure yours early to ensure
        inclusion
      </>,
    ],
  },
  {
    title: "Coffee Break Sponsor",
    description: (
      <>
        Gain visibility and refresh the crowd by sponsoring one of the
        conference’s most anticipated networking moments — the coffee break.
      </>
    ),
    price: "2,199",
    slot: "",
    details: [
      <>
        <strong>Branding at one official coffee break station </strong>(branded
        signage and display)
      </>,
      <>
        <strong>1 Full Conference Pass</strong>
      </>,
      <>
        <strong>1 Half-Page Advertisement</strong> in the official conference
        booklet or directory
      </>,
      <>
        <strong>Company Logo</strong> on the official conference website with a
        direct link to your site
      </>,
      <>
        {" "}
        <strong>Logo Placement</strong> on the main backdrop at the Opening
        Ceremony
      </>,
      <>
        <strong>Mention in Post-Event Highlights </strong>(digital and print)
      </>,
      <>Let your brand fuel meaningful conversations — one cup at a time.</>,
    ],
    sponsors: [
      {
        name: "2H GROUP LOGISTICS",
        logo: "2H-coffee-break.jpg",
        url: "https://2hgroup.com.tr/",
      },
    ],
  },
  {
    title: "F&B  Sponsor",
    description: (
      <>
        Looking to showcase your brand through sponsored drinks or signature
        beverages at the FIBS Global Conference? Whether it’s beer, gin, tonic
        water, or something unique — we offer curated opportunities to feature
        your products at select conference moments.
        <p className="pt-4 font-weight-bold">
          Let’s Create Something Together:
        </p>
        Please contact the event organiser to explore customised F&B sponsorship
        options that highlight your beverage brand and enhance the delegate
        experience.
      </>
    ),
    price: "123",
    slot: "",
    details: [],
  },
];

function Sponsor() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    event.preventDefault();
  };

  return (
    <>
      <Navbar />
      <SubHeader
        title="Be A Sponsor"
        image={require("assets/img/shakehand4.jpg")}
      />
      <div className="wrapper position-relative">
        <div className="container main my-lg-5 px-lg-5">
          <section className="section gb nopadtop">
            <div className="container">
              <div className="boxed boxedp4">
                <div className="row">
                  <div className="col-md-12 section-title">
                    <h2 className="text-center text-uppercase">
                      Affordable Sponsorship Pricing Packages
                    </h2>
                  </div>
                </div>

                <div className="text-justify">
                  <h4>
                    <strong>Why be a Sponsor?</strong>
                  </h4>

                  <p>
                    FIBS is hosting this conference to enhance relations with
                    selected partners.
                  </p>
                  <p>
                    This is a different event from most regular network company
                    events, as we are not making money on our partner and
                    friends. As we have a limited budget, the sponsorships help
                    us offer a better event for everyone.
                  </p>

                  <p>
                    The purpose of having a FIBS conference is to create a
                    productive meeting platform and build quality relationships.
                    Our goal is to make you leave the event with a smile and to
                    make you feel that you really leverage your time well.
                  </p>
                  <p>
                    We are confident that you will build long-lasting business
                    development with existing and new partners and friends.
                  </p>
                  <p>
                    The benefits of FIBS sponsorship act as a springboard to
                    further boost your efforts to forge solid connections.
                    Depending on the level of exposure you want, we are open to
                    discussing other sponsorship options.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {sponsorPackages.map((pkg, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card
                      className="bg-white shadow "
                      variant="outlined"
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* <CardContent> */}
                      <div className="sponsor-box">
                        <div className="text-center ">
                          <>
                            {index === 7 ? (
                              <h1
                                className="mb-0 pt-4 text-white"
                                style={{
                                  display: pkg.price === "" ? "none" : "block",
                                  userSelect: "none",
                                }}
                              >
                                {pkg.price}
                              </h1>
                            ) : (
                              <h1
                                className="mb-0 pt-4"
                                style={{
                                  display: pkg.price === "" ? "none" : "block",
                                }}
                              >
                                <small
                                  className="align-top text-muted font-weight-medium"
                                  style={{
                                    fontSize: "22px",
                                    lineHeight: "45px",
                                  }}
                                >
                                  USD $
                                </small>
                                {pkg.price}
                              </h1>
                            )}

                            {index === 4 ? (
                              <p
                                className="mb-3 text-white"
                                style={{ userSelect: "none" }}
                              >
                                Available Slot
                              </p>
                            ) : (
                              <p className="mb-3">{pkg.slot}</p>
                            )}
                          </>
                        </div>
                        <div className="bg-danger text-white text-center p-4">
                          <h3 className="m-0">{pkg.title}</h3>
                        </div>
                        <div className="p-3">
                          <span>{pkg.description}</span>
                        </div>
                        <div className="text-justify px-4">
                          <List dense>
                            {pkg.details.map((item, idx) => (
                              <ListItem key={idx} sx={{ pl: 0 }}>
                                <ListItemText primary={<span>• {item}</span>} />
                              </ListItem>
                            ))}
                          </List>
                          {pkg.sponsors && pkg.sponsors.length > 0 ? (
                            <div className="mb-4">
                              <p className="sponsoredBy my-2">Sponsored by</p>
                              <div className="flex justify-center items-center gap-4 flex-wrap h-16">
                                {pkg.sponsors.map((sponsor, sponsorIdx) => (
                                  <a href={sponsor.url} target="_blank">
                                    <img
                                      key={sponsorIdx}
                                      src={require(
                                        `assets/img/Macau-2026/sponsors/${sponsor.logo}`,
                                      )}
                                      alt={`${sponsor.name} Logo`}
                                      className="max-h-12 object-contain sponsor-logo py-3"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "";
                                      }}
                                    />
                                  </a>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div className="h-24 mb-4" />
                          )}
                        </div>

                        {/* </CardContent> */}
                      </div>
                      <div className="row justify-content-center pb-4">
                        <a
                          href="mailto:customerservice@zepoga.com"
                          className="btn btn-outline-danger py-2 px-4 my-2"
                        >
                          Email Us Now
                        </a>
                      </div>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </section>
          {/* <section>
            <Card
              className="bg-white shadow p-4 mt-5"
              variant="outlined"
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <h4 className="my-0 font-weight-bold">
                F&B Sponsorship – Customised Beverage Opportunities
              </h4>
              <p>
                Looking to showcase your brand through sponsored drinks or
                signature beverages at the FIBS Global Conference? Whether it’s
                beer, gin, tonic water, or something unique — we offer curated
                opportunities to feature your products at select conference
                moments.
              </p>
            </Card>
            <Card
              className="bg-white shadow p-4 mt-2 mb-5"
              variant="outlined"
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <h4 className="my-0 font-weight-bold">
                Let’s Create Something Together:
              </h4>
              <p>
                Please contact the event organiser to explore customised F&B
                sponsorship options that highlight your beverage brand and
                enhance the delegate experience.
              </p>
            </Card>
          </section> */}
        </div>

        {/* <div className="container">
          <div class="container1 row ">
            <div class="box12 col-lg-4 bg-white shadow sponsor-box">
              <div className="text-center p-4">
                <h1 className="mb-0">
                  <small
                    className="align-top text-muted font-weight-medium"
                    style={{ fontSize: "22px", lineHeight: "45px" }}
                  >
                    $
                  </small>
                  1,999
                </h1>
              </div>
              <div className="bg-danger text-white text-center p-4">
                <h3 className="m-0">Coffee Break </h3>
              </div>
              <div className="d-flex flex-column px-3 py-4">
                <ul>
                  <li>
                    1 VIP Table (all one 2 one meetings at your dedicated table)
                  </li>
                  <li>
                    <strong>2 passes to the conference</strong>
                  </li>
                  <li>Toast at the cocktail party</li>
                  <li>Staplers with sponsor logo on every F2F table</li>
                  <li>
                    1 full-page print advertisement in the conference booklet /
                    directory
                  </li>
                  <li>
                    Company logo on conference website with a link to company
                    website
                  </li>
                  <li>Stand-up banner with company logo at VIP table</li>
                  <li>Company Logo on backdrop at opening ceremony </li>
                  <li>
                    Company logo to be shown at after-conference movie /
                    materials{" "}
                  </li>
                </ul>
              </div>
              <div className="row justify-content-center pb-4 card-bottom">
                <a
                  href="mailto:customerservice@zepoga.com"
                  className="btn btn-outline-danger py-2 px-4 my-2"
                >
                  Email Us Now
                </a>
              </div>
            </div>
            <div class="box12 col-lg-4 bg-white shadow sponsor-box">
              <div className="text-center p-4">
                <h1 className="mb-0">
                  <small
                    className="align-top text-muted font-weight-medium"
                    style={{ fontSize: "22px", lineHeight: "45px" }}
                  >
                    $
                  </small>
                  1,999
                </h1>
              </div>
              <div className="bg-danger text-white text-center p-4">
                <h3 className="m-0">Coffee Break </h3>
              </div>
              <div className="d-flex flex-column px-3 py-4">
                <ul>
                  <li>Logo on all golf related market materials</li>
                  <li>Popup stands at tee off</li>
                  <li>Golf price presented as sponsor of the event</li>
                  <li>Cap with logo</li>
                </ul>
              </div>
              <div className="row justify-content-center pb-4 card-bottom">
                <a
                  href="mailto:customerservice@zepoga.com"
                  className="btn btn-outline-danger py-2 px-4 my-2"
                >
                  Email Us Now
                </a>
              </div>
            </div>
            
            <div class="card box12 col-lg-4 bg-white shadow sponsor-box">
           
                <div class="card-header text-center">
                  <h1 className="mb-0">
                    <small
                      className="align-top text-muted font-weight-medium"
                      style={{ fontSize: "22px", lineHeight: "45px" }}
                    >
                      $
                    </small>
                    1,999
                  </h1>

                  <div className="bg-danger text-white text-center p-4">
                    <h3 className="m-0">Coffee Break </h3>
                  </div>
                </div>
                <div class="card-body px-3 py-4">
                  <ul>
                    <li>
                      <strong>1 passes to the conference</strong>
                    </li>
                    <li>
                      1 half-page print advertisement in the conference booklet
                      / directory.
                    </li>
                    <li>
                      Company logo on conference website with a link to company
                      website
                    </li>
                    <li>Company Logo on backdrop at opening ceremony </li>
                    <li>
                      Logo printing on 2 banners at coffee station (s) each day
                    </li>
                    <li>
                      Company logo to be shown at after-conference movie
                      /materials{" "}
                    </li>
                  </ul>
                </div>
                <div class="card-footer text-muted">
                  <a
                    href="mailto:customerservice@zepoga.com"
                    className="btn btn-outline-danger py-2 px-4 my-2"
                  >
                    Email Us Now
                  </a>
                </div>
            </div>
          </div>
        </div> */}

        {/* <PanelCountdown date="03/03/2026" /> */}
        <DarkFooter />
      </div>
    </>
  );
}

export default Sponsor;
